module.exports = __webpack_public_path__ + "static/media/lambda.86ce4f1c.svg";